'use client';

import EventConfig from '@foxcorp/foxkit-event-js/destination-config';
import Heap from '@foxcorp/foxkit-event-js/heap';

import { getUiConfig } from '@/config/client/getUiConfig';
import { getXid } from '@/features/auth/client';

type EnvMap = Record<'dev' | 'stage' | 'production', 'dev' | 'qa' | 'staging' | 'prod'>;

const envMap: EnvMap = {
  dev: 'dev',
  stage: 'staging',
  production: 'prod',
};

let heapInitialized = false;

export async function getHeapInstance(): Promise<typeof window.heap | false> {
  if (!heapInitialized) {
    await getXid();

    const uiConfig = getUiConfig();

    const eventConfig = new EventConfig({
      appName: uiConfig.appName,
      appVersion: uiConfig.appVersion,
      appId: uiConfig.heapAppId,
      environment: envMap[uiConfig.environment],
    });

    // eslint-disable-next-line no-new -- SDK exception
    new Heap(eventConfig);
    heapInitialized = true;
  }

  return await waitForWindowHeapLoaded();
}

function waitForWindowHeapLoaded(timeout = 2000): Promise<typeof window.heap | false> {
  return new Promise((resolve, _reject) => {
    const start = Date.now();

    function check(): void {
      // @ts-expect-error: Heap adds .loaded after init

      if (typeof window !== 'undefined' && window.heap.loaded) {
        resolve(window.heap);
      } else if (Date.now() - start > timeout) {
        console.debug('unable to resolve window.heap.loaded after 2 second ');
        resolve(false);
      } else {
        setTimeout(check, 50);
      }
    }

    check();
  });
}
